/**
 * Created by chenqifeng on 2016/9/1.
 */

import {
    request
} from '../http';
import domain from '../domain';

var CouponServer = function() {
    if (domain.env === 'online') {
        this.domain = "//coupon.51tiangou.com";
    } else {
        this.domain = "//coupon." + domain.env + ".66buy.com.cn";
    }
};

CouponServer.prototype.activityQcList = function(params = {}) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/activity/qc/list", params);
};
CouponServer.prototype.activityRuleGet = function(params = {}) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/activity/rule/get", params);
};

CouponServer.prototype._serviceAjaxCom = function(url, params) {
    params.url = this.domain + url;
    return request(params);
};
/**
 * 礼品卡详情查询
 * @param params
 */
 CouponServer.prototype.giftCardInformation = function(params = {}) {
     var that = this;
     params.type = 'POST';
     return that._serviceAjaxCom("/publics/weBankGiftCard/information", params);
 };
 /**
  * 礼品卡线上使用核销
  * @param params
  */
  // CouponServer.prototype.giftCardOnlineVerify = function(params = {}) {
  //     var that = this;
  //     params.type = 'POST';
  //     return that._serviceAjaxCom("/publics/weBankGiftCard/onlineVerify", params);
  // };
/**
 * 查询是否可以申请礼品卡退货
 * @param params
 */
CouponServer.prototype.queryReturnApply = function(params = {}) {
    var that = this;
    params.type = 'POST';
    return that._serviceAjaxCom("/publics/weBankGiftCard/queryReturnApply", params);
};
/**
 * 礼品卡退货
 * @param params
 */
CouponServer.prototype.returnApply = function(params = {}) {
    var that = this;
    params.type = 'POST';
    return that._serviceAjaxCom("/publics/weBankGiftCard/returnApply", params);
};
/**
 * 领取优惠券
 * @param params
 */
CouponServer.prototype.couponCodeAdd = function(params = {}) {
    var that = this;
    params.type = 'POST';
    params.needSecKey = true;
    return that._serviceAjaxCom("/publics/couponCode/add", params);
};
/**
 * 领取支付返券分享的券或者券包分享的券
 * @param params
 */
CouponServer.prototype.addShareCouponCode = function(params = {}) {
    var that = this;
    params.type = 'POST';
    return that._serviceAjaxCom("/publics/addShareCouponCode", params);
};
/**
 * 扫码个性推荐活动优惠券列表
 * @param params
 */
CouponServer.prototype.webankCouponAdd = function(params = {}) {
    var that = this;
    params.type = 'GET';
    params.url = "//coupon.51tiangou.com/publics/weBank/activity/coupon";
    return that._serviceAjaxCom("/publics/weBank/activity/coupon", params);
    //request(params);
};
/**
 * 领取优惠券 猜你喜欢线上测试用
 * @param params
 */
CouponServer.prototype.couponCodeAddTest = function(params = {}) {
    var that = this;
    params.type = 'POST';
    params.needSecKey = true;
    params.url = "//coupon.51tiangou.com/publics/couponCode/add"
    request(params);
};
//递增参团人数
CouponServer.prototype.increaseGroupCount = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/activity/increaseGroupCount", params);
};

//递增参团人数
CouponServer.prototype.addAndGetPayReturnCoupon = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/addAndGetPayReturnCoupon", params);
};

//查询商品是否有可领取使用的优惠券
CouponServer.prototype.hasCouponByItemId = function (params) {
    var that = this;
    params.type = 'GET';
    that._serviceAjaxCom("/publics/isHaveDeliveryGetValidCoupon", params);
};

//狗粮换券
CouponServer.prototype.addByPoint = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/couponCode/addByPoint", params);
};

//专柜团品牌列表
CouponServer.prototype.getBrandNames = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/activity/getBrandNames", params);
};


/**
 * 专柜团订单详情查询
 */
CouponServer.prototype.getGroupOrderDetail = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/group/orderDetail", params);
};

//专柜团活动详情
CouponServer.prototype.getCounterGroupDetail = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/activity/getCounterGroupDetail", params);
};

//查商品对应的券
CouponServer.prototype.getProductCoupon = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/getCouponListForDetailsPage", params);
};

//批量查商品对应的券
CouponServer.prototype.getProductCouponList = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/coupon/activity/promotion/isHave", params);
};

/**
 * 2018 世界杯投票平台预测结果页面
 * */
CouponServer.prototype.worldCupPlatformForecast = function(params){
    params.type = 'POST';

    this._serviceAjaxCom('/publics/activity/queryPlatformForecast', params);
};
/**
 * 2018 世界杯用户投票
 * @param   {Object}    params
 * @param   {Object}    params.data
 * @param   {string}    params.data.quarterfinals   所选队伍数组的 json 字符串
 * @desc    [{group, groupIndex, champion}] 所属分组，组内序号，是否为冠军
 * */
CouponServer.prototype.worldCupForecast = function(params){
	params.type = 'POST';

	this._serviceAjaxCom('/publics/activity/forecastWorldCup', params);
};

/**
 * 2018 世界杯用户投票结果查询
 * */
CouponServer.prototype.worldCupForecastQuery = function(params){
    params.type = 'POST';

    this._serviceAjaxCom('/publics/activity/queryForecast', params);
};

/**
 * 活动详情查询
 * @param   {Object}    params
 * @param   {Object}    params.data
 * @param   {number}    params.data.activityId
 * */
CouponServer.prototype.activityDetail = function(params){
    this._serviceAjaxCom('/publics/activity/detail', params);
};
/**
 * 券详情查询
 * @param   {Object}    params
 * */
CouponServer.prototype.couponDetail = function(params){
    this._serviceAjaxCom('/publics/coupon/detail', params);
};
/**
 * 券适用门店列表
 * @param   {Object}    params
 * */
CouponServer.prototype.couponStoreList = function(params){
    this._serviceAjaxCom('/publics/coupon/queryStoreList', params);
};

/**
 * 获取广告位
 * @param   {Object}    params
 * @param   {Object}    params.data
 * @param   {number}    params.data.pageType
 * @param   {number}    params.data.cityId
 * @param   {number}    params.data.advModuleId
 * @param   {number}    params.data.storeId
 * */
CouponServer.prototype.advModule = function(params){
    this._serviceAjaxCom('/publics/tgAd/advModule', params);
};

CouponServer.prototype.queryActivityRuleInfo = function(params){
    params.type = 'POST';

    return this._serviceAjaxCom('/publics/activity/queryActivityRuleInfo', params);
};

/**
 * 大转盘活动 存储邮寄地址
 */
CouponServer.prototype.saveLotteryAddr = function(params){
    params.type = 'POST';

    return this._serviceAjaxCom('/publics/lottery/mallLottery/saveLotteryAddr', params);
};

/**
 * 获取优惠券品牌 couponState(必填) source(必填)
 */
CouponServer.prototype.queryBrands  = function(params) {
    this._serviceAjaxCom("/publics/couponCode/queryBrands", params);
};

/**
 * 通过店铺和专柜查询当前能够领取的优惠券
 * @param params
 */
CouponServer.prototype.queryByCounter  = function(params){
    this._serviceAjaxCom("/publics/coupon/scQuery", params);
};

/**
 * 领取亚马逊项目优惠券
 * @param params
 */
CouponServer.prototype.addAmazonCoupon  = function(params){
    params.type="POST";
    this._serviceAjaxCom("/publics/coupon/r/add", params);
};

/**
 *  拼团-根据订单ID  获取分享信息 （分享专用)
 * @param params
 */
CouponServer.prototype.getShareInfoByOrderId  = function(params){
    params.type="POST";
    this._serviceAjaxCom("/publics/activity/groupPurchase/getShareInfoByOrderId", params);
};

CouponServer.prototype.conflictVerify = function(params){
    params.type = 'POST';
    return this._serviceAjaxCom('/publics/conflictVerify', params);
};

/**
 * @param   params
 * @param   params.data
 * @param   params.data.fastDelivery
 * @param   params.data.canDelivery
 * @param   params.data.pickupRule
 * */
CouponServer.prototype.storeRuleDesc = function(params){
    params.type = 'POST';
    return this._serviceAjaxCom('/publics/store/rule/desc', params);
};
/**
 * @param   params
 * @param   params.data
 * @param   params.data.fastDelivery
 * @param   params.data.canDelivery
 * @param   params.data.pickupRule
 * */
CouponServer.prototype.upVipOrderDiscount = function (params) {
    params.type = 'POST'
    return this._serviceAjaxCom('/publics/activity/firstVip/discounts/order', params);

}
/**
 * 会员续费提醒 我的，商品详情等页面
 * @param params
 * @returns {*}
 */
CouponServer.prototype.upVipRenew = function (params) {
    params.type = "POST";
    return this._serviceAjaxCom("/publics/activity/renew/vip/item", params);
}
/**
 * 会员续费提醒 购物车，提交订单页面
 * @param params
 * @returns {*}
 */
CouponServer.prototype.upVipRenewOrder = function (params) {
    params.type = "POST";
    return this._serviceAjaxCom("/publics/activity/renew/vip/order", params);
}

/**
 * #51357 获取商品水印接口
 * */
CouponServer.prototype.getWatermarkByItemList = function(params){
    params.type = "GET";
    return this._serviceAjaxCom('/front/listing/batchGetTag', params);
};

/**
 * #55636 新人弹窗
 * */
CouponServer.prototype.newerPriceProduct = function(params){
    params.type = "GET";
    return this._serviceAjaxCom('/publics/content/queryNewerPriceProduct', params);
};

/**
 * #56705 双十一特殊券推送信息
 * */
CouponServer.prototype.sendDetail = function(params){
    params.type = "GET";
    return this._serviceAjaxCom('/publics/push/coupon/sendDetail', params);
};

/**
 * #56705 双十一特殊券 发送券给用户
 * */
CouponServer.prototype.send = function(params){
    params.type = "POST";
    return this._serviceAjaxCom('/publics/push/coupon/send', params);
};

/**
 * #56705 双十一订单推送券
 * */
CouponServer.prototype.orderSend = function(params){
    params.type = "POST";
    return this._serviceAjaxCom('/publics/push/coupon/orderSend', params);
};

/**
 * #56493 确认订单弹窗领取优惠券
 * */
CouponServer.prototype.receiveCoupon = function(params){
    params.type = "POST";
    return this._serviceAjaxCom('/publics/receiveCouponListForDetailsPage', params);
};

/**
 * #57719 跨境店铺展示会员入口
 * */
CouponServer.prototype.showVipStore = function(params){
    params.type = "GET";
    return this._serviceAjaxCom('/publics/show/vipPortal', params);
};
export default new CouponServer();
